import { render } from "./FilterDistributorDerivatives.vue?vue&type=template&id=112d2056"
import script from "./FilterDistributorDerivatives.vue?vue&type=script&lang=js"
export * from "./FilterDistributorDerivatives.vue?vue&type=script&lang=js"
script.render = render

export default script